// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"9246b994","583":"4c6d45b8","983":"6f6e32a7"}[chunkId] + ".chunk.js";
};